import { z } from "zod"

const stepOneSchema = z.object({
  start_date: z.date("Check-in date is required."),
  over_12_months: z.enum(["under", "over"], {
    errorMap: () => ({ message: 
      "Rent retention is invalid."}),
  }),
  end_date: z.date().nullable(),
  how_many_people: z
    .number({
      invalid_type_error: "Number of people must be a number.",
    })
    .int()
    .min(1, "Number of people must be at least 1.")
    .max(9, "Number of people must be at most 9."),
})

const stepTwoSchema = z.object({
  age: z
    .number({
      invalid_type_error: "Age must be filled.",
    })
    .int()
    .min(18, "Age must be at least 18.")
    .max(99, "Max. age allowed is 99."),
  gender: z.enum(["M", "F", "notSpecified"], {
    errorMap: () => ({ message: "Gender is invalid."}),
  }),
  profession: z.enum(["italianStudent", "foreignStudent", "selfEmployed", "employee"], {
    errorMap: () => ({ message: "Profession is invalid."}),
  }),
  nationality: z.string({ required_error: "Country is required."}).min(1),
  phone_number: z.string().optional(),
  about_yourself: z.string().min(1, "About yourself is required."),
})

const stepThreeSchema = z.object({
  flexibility_status: z.string().min(1, "Payment plan is required.").nullable()
})

const stepFourSchema = (minPrice) =>
  z.object({
    terms_and_conditions: z
      .boolean()
      .refine(val => val === true, {
        message: 'You must accept the terms and conditions.',
      }),
    tenant_proposal: z
      .number()
      .refine(val => val >= minPrice, {
        message: `Your offer must be at least greater than €${minPrice}`,
      }),
  })

export { stepOneSchema, stepTwoSchema, stepThreeSchema, stepFourSchema }